var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5C4 4.44772 4.44772 4 5 4H10.4667C11.019 4 11.4667 4.44772 11.4667 5V12C11.4667 12.5523 11.019 13 10.4667 13H5C4.44772 13 4 12.5523 4 12V5Z",
    fill: "#314361"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 5.5V11.5H9.96667V5.5H5.5ZM5 4C4.44772 4 4 4.44772 4 5V12C4 12.5523 4.44772 13 5 13H10.4667C11.019 13 11.4667 12.5523 11.4667 12V5C11.4667 4.44772 11.019 4 10.4667 4H5Z",
    fill: "#314361"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12C20 11.4477 19.5523 11 19 11H13.5333C12.981 11 12.5333 11.4477 12.5333 12V19C12.5333 19.5523 12.981 20 13.5333 20H19C19.5523 20 20 19.5523 20 19V12Z",
    fill: "#314361"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 12.5V18.5H14.0333V12.5H18.5ZM19 11C19.5523 11 20 11.4477 20 12V19C20 19.5523 19.5523 20 19 20H13.5333C12.981 20 12.5333 19.5523 12.5333 19V12C12.5333 11.4477 12.981 11 13.5333 11H19Z",
    fill: "#314361"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5333 5C12.5333 4.44772 12.981 4 13.5333 4H19C19.5523 4 20 4.44772 20 5V9C20 9.55228 19.5523 10 19 10H13.5333C12.981 10 12.5333 9.55228 12.5333 9V5Z",
    fill: "#314361"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0333 5.5V8.5H18.5V5.5H14.0333ZM13.5333 4C12.981 4 12.5333 4.44772 12.5333 5V9C12.5333 9.55228 12.981 10 13.5333 10H19C19.5523 10 20 9.55228 20 9V5C20 4.44772 19.5523 4 19 4H13.5333Z",
    fill: "#314361"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4667 15C11.4667 14.4477 11.019 14 10.4667 14H5.00001C4.44772 14 4.00001 14.4477 4.00001 15V19C4.00001 19.5523 4.44772 20 5.00001 20H10.4667C11.019 20 11.4667 19.5523 11.4667 19V15Z",
    fill: "#314361"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.96667 15.5V18.5H5.50001V15.5H9.96667ZM10.4667 14C11.019 14 11.4667 14.4477 11.4667 15V19C11.4667 19.5523 11.019 20 10.4667 20H5.00001C4.44772 20 4.00001 19.5523 4.00001 19V15C4.00001 14.4477 4.44772 14 5.00001 14H10.4667Z",
    fill: "#314361"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardFilled);
export default __webpack_public_path__ + "static/media/dashboard_filled.996652b4cd9ecbc7e4ab4c85e181f6db.svg";
export { ForwardRef as ReactComponent };